<button [className]="color + '-bg'">
  <app-icon *ngIf="!!icon" [src]="icon"></app-icon>
  <span class="text">{{ text }}</span>
</button>
